import script from "./EVConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./EVConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./EVConfiguration.vue?vue&type=style&index=0&id=78312eda&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78312eda"]])

export default __exports__